/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  


$(document).ready(function() {
	$("form#order-form").trigger("reset");

	$("form#order-form").on("change", function () {
		console.log("changed")
		var selection = $(this).find("input[name='id']:checked");
		var plan = $(this).find("input[name='subscribe']:checked");
		var sellingPlanInput = $(this).find("input[name='selling_plan']");
		var sellingPlanID = $(selection).data("selling-plan");
		// var productID = $(selection).data("product-ID");
		// var handle = $(selection).data("handle");
		var handleone = $(selection).data("handleone");
		var handletwo = $(selection).data("handletwo");
		var handlethree = $(selection).data("handlethree");
		var handleoneOTP = $(selection).data("handleone-otp");
		var handletwoOTP = $(selection).data("handletwo-otp");
		var handlethreeOTP = $(selection).data("handlethree-otp");
		var numBottles = $(selection).data("num-bottles");
		var sellingPlan = $(plan).val();
		var subscription;
		var additionalSavings;
		var shipsevery;

		if (sellingPlan === "1") {
			$("#option-one-radio").val($("#option-one-radio").data("variant1"));
			$("#option-two-radio").val($("#option-two-radio").data("variant2"));
			$("#option-three-radio").val($("#option-three-radio").data("variant3"));

			$.getJSON(window.Shopify.routes.root + 'products/' + handleone + '.js', function(product) {
				console.log(product)
				// var one_price = product.price / 100;
				// var one_subscriptionDiscount = (product.selling_plan_groups[0].selling_plans[0].price_adjustments[0].value) / 100;
				var one_subscriptionPrice = product.price / 100;
				// if (sellingPlan === "1") {
					$(".variant1price").text(one_subscriptionPrice.toFixed(2));
				// } else {
				// 	$(".variant1price").text(one_price.toFixed(2));
				// }
			});
	
			$.getJSON(window.Shopify.routes.root + 'products/' + handletwo + '.js', function(product) {
				// var two_price = product.price / 100;
				// var two_subscriptionDiscount = (product.selling_plan_groups[0].selling_plans[0].price_adjustments[0].value) / 100;
				var two_subscriptionPrice = product.price / 100;
				// if (sellingPlan === "1") {
					$(".variant2price").text(two_subscriptionPrice.toFixed(2));
				// } else {
				// 	$(".variant2price").text(two_price.toFixed(2));
				// }
			});
			
			$.getJSON(window.Shopify.routes.root + 'products/' + handlethree + '.js', function(product) {
				// var three_price = product.price / 100;
				// var three_subscriptionDiscount = (product.selling_plan_groups[0].selling_plans[0].price_adjustments[0].value) / 100;
				var three_subscriptionPrice = product.price / 100;
				// if (sellingPlan === "1") {
					$(".variant3price").text(three_subscriptionPrice.toFixed(2));
				// } else {
				// 	$(".variant3price").text(three_price.toFixed(2));
				// }
			});
		} else {
			$("#option-one-radio").val($("#option-one-radio").data("variant1-otp"));
			$("#option-two-radio").val($("#option-two-radio").data("variant2-otp"));
			$("#option-three-radio").val($("#option-three-radio").data("variant3-otp"));

			$.getJSON(window.Shopify.routes.root + 'products/' + handleoneOTP + '.js', function(product) {
				console.log(product);
				var one_price = product.price / 100;
				// var one_subscriptionDiscount = (product.selling_plan_groups[0].selling_plans[0].price_adjustments[0].value) / 100;
				// var one_subscriptionPrice = (1 - one_subscriptionDiscount) * one_price;
				// if (sellingPlan === "1") {
				// 	$(".variant1price").text(one_subscriptionPrice.toFixed(2));
				// } else {
					$(".variant1price").text(one_price.toFixed(2));
				// }
			});
	
			$.getJSON(window.Shopify.routes.root + 'products/' + handletwoOTP + '.js', function(product) {
				var two_price = product.price / 100;
				// var two_subscriptionDiscount = (product.selling_plan_groups[0].selling_plans[0].price_adjustments[0].value) / 100;
				// var two_subscriptionPrice = (1 - two_subscriptionDiscount) * two_price;
				// if (sellingPlan === "1") {
				// 	$(".variant2price").text(two_subscriptionPrice.toFixed(2));
				// } else {
					$(".variant2price").text(two_price.toFixed(2));
				// }
			});
			
			$.getJSON(window.Shopify.routes.root + 'products/' + handlethreeOTP + '.js', function(product) {
				var three_price = product.price / 100;
				// var three_subscriptionDiscount = (product.selling_plan_groups[0].selling_plans[0].price_adjustments[0].value) / 100;
				// var three_subscriptionPrice = (1 - three_subscriptionDiscount) * three_price;
				// if (sellingPlan === "1") {
				// 	$(".variant3price").text(three_subscriptionPrice.toFixed(2));
				// } else {
					$(".variant3price").text(three_price.toFixed(2));
				// }
			});
		}

		

		if (sellingPlan === "1") {
			subscription = true;
			sellingPlanInput.val(sellingPlanID);
			$(".shipseverywording").show();
			$(".savings-subscription").show();
			$(".savings-subscription-percent").show();
			$(".savings-otp").hide();
		} else {
			subscription = false;
			sellingPlanInput.val("");
			$(".shipseverywording").hide();
			$(".savings-subscription").hide();
			$(".savings-subscription-percent").hide();
			$(".savings-otp").css('display','inline');
		}
		
		switch (numBottles) {
			case 6:
				additionalSavings = "22.50";
                shipsevery = "180";
				break;
			case 3:
				additionalSavings = "12.75";
                shipsevery = "90";
				break;
			case 1:
				additionalSavings = "5.00";
                shipsevery = "30";
				break;
			default: // 3 bottles
				additionalSavings = "12.75";
                shipsevery = "90";
				break;
		}
	
		
		$(".additional-savings").text(additionalSavings);
        $(".shipsevery").text(shipsevery);
		
//		$.getJSON(window.Shopify.routes.root + 'products/' + handle + '.js', function(product) {
//	
//			var price = product.price / 100;
//			var bottlePrice = price / numBottles;
//			var subscriptionDiscount = (product.selling_plan_groups[0].selling_plans[0].price_adjustments[0].value) / 100;
//			var subscriptionPrice = (1 - subscriptionDiscount) * bottlePrice;
//	
//			if (subscription) {
//				$(".pro-price__new").text(subscriptionPrice.toFixed(2));
//			} else {
//				$(".pro-price__new").text(bottlePrice.toFixed(2));
//			}
//			
//		});
	
		
	})
}); 


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
